/*
 * @Author: wangyu
 * @since: 2023-09-05 10:15:26
 * @lastTime: 2023-11-09 17:47:23
 * @LastEditors: caiqin.xie
 * @message: 表单组件
 */
import React from "react";
import { Select, Form, Input } from "@arco-design/web-react";
const FormItem = Form.Item;
const Option = Select.Option;

const formType = (props: any) => {
    const { inputList } = props;
    return (
        <div>
            {inputList.map((item: any) => {
                return (
                    <FormItem label field={item.key} rules={item.rules} extra={item.extra} key={item.key}>
                        {
                            InputItem(item)
                        }
                    </FormItem>
                )
            })}
        </div >
    );
};

const InputItem = (item: any) => {
    switch (item.name) {
        case "selected":
            return (
                <Select placeholder={item.placeHolder}>
                    {item.selectedListKey.map((option: any) => (
                        <Option key={option.key} value={option.value}>
                            {option.label}
                        </Option>
                    ))}
                </Select>
            );
        case "input":
            return (<Input placeholder={item.placeHolder} key={item.key} />);
    }
}
export default formType
